import { call } from 'redux-saga/effects';

import createWorker from 'app/redux/utils/create-worker';
import workInterval from 'app/redux/utils/work-interval';

import constants from 'app/constants/cache';

import mediaAPI from 'app/api/media';

const execute = function*() {
  return yield call(mediaAPI.getAllMedia);
};

export const {
  Actions,
  Generators,
  ReducerHandlers,
  Saga,
  Types,
  initState,
  localStateSelector,
  Selectors,
} = createWorker('media/get-all', {
  localStateSelector: 'mediaGetAll',
  execute,
  shouldWork: workInterval(constants.defaultUpdateIntervalInMilliseconds),
  takePolicy: 'latest',
});



// WEBPACK FOOTER //
// ./src/redux/media/get-all/workers.js